import React from "react";

interface PublicProviderProps {
  children?: React.ReactNode;
}

export const Public = ({ children }: PublicProviderProps) => {
  return <>{children}</>;
};
